import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom'; 
import classNames from 'classnames';
import GridTitleAndCount from '../../portal/gridTitleAndCount';
import styles from './styles.scss';

export default class GridTooltip extends Component {
    
    getGridTitle = () => {
        const { itemId, defaultName, count } = this.props;

        return( 
            <div className='grid-and-title-wrapper'  >
                <GridTitleAndCount dataFor={itemId} title={defaultName} count={`+${count - 1}`} />
            </div>);
    }

    getTooltipListItem = item => this.props.isRolesTooltip && this.props.IsUserAllowedToAccessRoles ? <Link to={`/roles/${item.id}/`}> {item.name} </Link> : item.name;

    getTooltip = () => {
        const { items, translations, itemId, count } = this.props;
        
        return (
            <ReactTooltip
                id={itemId}  
                isCapture 
                clickable 
                event='click'
                globalEventOff="click" 
                type='light' 
                effect='solid'
                className='general-tooltip' 
                >
                <h4>
                    {count + ' ' + translations.title + ':'}
                </h4>
                <ul className={classNames(styles.gridTooltipList)}>
                    {items.map((item, inx) => {
                        return (
                            <li key={inx} className='ellipsis'>
                                {this.getTooltipListItem(item)}
                            </li>
                        );
                    })}
                </ul>
            </ ReactTooltip>
        );
    }

    render() {
        return (
            <div>
                {this.getGridTitle()}
                {this.getTooltip()}
            </div>);
    }
}